import { QueryState } from '@/common/enum';
import { Nullable } from 'interfaces/Nullable.ts';
import { IADetails } from 'interfaces/ia.interface.ts';

export type IAStateTypes = {
  queryState: QueryState;
  error: Nullable<string>;
  iaDataset: Nullable<IADetails[]>;
  currentEntry: Nullable<IADetails>;
  fetchProgress: number;
  syncProgress: number;
};

export const IAInitialState: IAStateTypes = {
  queryState: QueryState.UNDEFINED,
  error: null,
  iaDataset: null,
  currentEntry: null,
  fetchProgress: 0,
  syncProgress: 0,
};
